import styled, { keyframes } from 'styled-components';
import { COLOR_LIGHT_GRAY } from 'shared/helpers/colors';

const fadeOutTwo = keyframes`
  from {
    opacity: 0;
    transform: translate(-10px, -50%);
  }
  to {
    opacity: 1;
    transform: translate(0, -50%);
  }
`;

const IconInner = styled.div`
  position: absolute;
  right: -98px;
  padding: 0px 30px 0px 30px;
  top: 50%;
  transform: translateY(-50%);
  animation: ${fadeOutTwo} 0.3s ease-in-out;
  height: 100%;
  display: flex;
  align-items: center;
`;

const SettingsIcon = styled.div`
  width: 64px;
  height: 64px;
  background: ${COLOR_LIGHT_GRAY};
  border-radius: 9px;
  padding: 7px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const SetBtn = styled.div`
  background: #fff;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 1px solid #acacac;
  border-radius: 50%;

  img {
    width: 70%;
    height: 70%;
    object-fit: contain;
  }

  &:hover {
    background: #121212;
    transition: background 0.2s ease;
    cursor: pointer;
    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(331deg) brightness(103%) contrast(100%);
    }
  }
`;

type ButtonSettingIconProps = {
  setIsButtonActionModalOpen: (isOpen: boolean) => void;
  setShowLinkIcon: (show: boolean) => void;
};

const ButtonSettingIcon = (props: ButtonSettingIconProps) => {
  const { setIsButtonActionModalOpen, setShowLinkIcon } = props;
  return (
    <IconInner>
      <SettingsIcon
        onClick={() => {
          setIsButtonActionModalOpen(true);
          setShowLinkIcon(true);
        }}>
        <SetBtn>
          <img src="/img/link_icon.svg" alt="link button" />
        </SetBtn>
      </SettingsIcon>
    </IconInner>
  );
};

export default ButtonSettingIcon;
